angular.module('dentalLinks')
    .controller('ProcedureBlockController', ['$scope', 'Procedure', 'ReferralHelper', 'Notification',
        function ($scope, Procedure, ReferralHelper, Notification) {
            $scope.procedures = Procedure.query();
            $scope.practiceTypes = [];

            Procedure.practiceTypes(function(success){
                success.map(function(item){
                    if(item.code !== 'multi_specialty'){
                        $scope.practiceTypes.push(item);
                    }
                });
                // a type picked before the list arrived (DCL-682)
                ReferralHelper.applyPendingPracticeType($scope);
            }, function () {
                // the error interceptor only reports this to Rollbar
                Notification.error('Referral types could not be loaded. Please reload the page.');
            });
        }]);
